export default {
      id: "Icon--embed-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--embed",
      toString: function () {
        return this.url;
      }
    }